import { render, staticRenderFns } from "./ManualActividadPage.vue?vue&type=template&id=044023a4"
import script from "./ManualActividadPage.js?vue&type=script&lang=js&external"
export * from "./ManualActividadPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports